import { FC, SVGAttributes } from 'react';

type LogoSvgProps = SVGAttributes<SVGElement>;

export const LogoSvg: FC<LogoSvgProps> = ({ ...props }) => {
    return (
        <svg width="42" height="36" viewBox="0 0 42 36" fill="none" {...props}>
            <g clipPath="url(#clip0_906_6891)">
                <path
                    d="M26.9106 13.2107C25.6986 15.4208 19.4006 14.2337 12.8395 10.561C6.50721 7.01585 2.24906 2.44999 3.04718 0.148828C3.09291 0.0166818 3.24842 -0.0379992 3.36963 0.0280737L26.9084 13.2085L26.9106 13.2107Z"
                    fill="#DB5311"
                />
                <path
                    d="M26.9097 13.2099C26.5621 15.7115 20.2595 16.8849 12.834 15.8323C5.66469 14.8138 0.0710139 12.0957 0.000121011 9.65789C-0.00445272 9.51891 0.121325 9.40954 0.258537 9.42777L26.9074 13.2076L26.9097 13.2099Z"
                    fill="#DB5311"
                />
                <path
                    d="M26.9097 13.2109C28.307 15.3048 24.4033 20.4379 18.1853 24.678C12.1845 28.77 6.22726 30.5311 4.56013 28.7677C4.46408 28.6674 4.48695 28.5011 4.60129 28.4214L26.9097 13.2109Z"
                    fill="#10B5A8"
                />
                <path
                    d="M26.909 13.2109C28.9581 14.66 27.1309 20.8663 22.8316 27.0748C18.6809 33.067 13.7435 36.8719 11.5619 35.8284C11.4361 35.7691 11.3972 35.6051 11.4773 35.4912L26.909 13.2109Z"
                    fill="#175773"
                />
                <path
                    d="M26.9099 13.2109L19.7383 23.5639C25.0347 19.5767 28.186 15.1248 26.9099 13.2109Z"
                    fill="#027B77"
                />
                <path
                    d="M26.9093 13.2109C27.4718 15.6716 22.0062 19.0504 14.6997 20.7569C7.39314 22.4634 1.45872 21.8915 0.530248 19.6405C0.47765 19.5106 0.555404 19.3648 0.690329 19.3329L26.9093 13.2109Z"
                    fill="#F3A900"
                />
                <path
                    d="M26.909 13.2109L14.7246 16.0543C21.2994 16.6718 26.5912 15.4961 26.909 13.2109Z"
                    fill="#C0450C"
                />
                <path
                    d="M28.7872 13.4166C29.1422 13.6182 41.6112 20.5897 41.6112 20.5897C41.8789 20.7386 42.1362 20.3812 41.9181 20.1658C41.9181 20.1658 33.3523 11.9086 32.5639 11.3701C31.7756 10.8316 30.3915 10.4322 29.2374 11.8405C29.2374 11.8405 28.803 12.391 28.6227 12.624C28.4425 12.857 28.4322 13.2149 28.7872 13.4166Z"
                    fill="#175773"
                />
            </g>
            <defs>
                <clipPath id="clip0_906_6891">
                    <rect width="42" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
